export default "__VITE_ASSET__63b9b48c__"